import { fetchWrapper } from '@/helpers'
const ruta = process.env.VUE_APP_ROOT_API

export default class AgendaService {
  async obtenerListado(data) {
    return await fetchWrapper.post(`${ruta}/agendas/listado`, data)
  }

  async getAgenda(id) {
    return await fetchWrapper.get(`${ruta}/agendas/${id}`)
  }

  async guardar(datos) {
    return await fetchWrapper.post(`${ruta}/agendas/crear`, datos)
  }

  async actualizar(datos) {
    return await fetchWrapper.put(`${ruta}/agendas/actualizar`, datos)
  }

  async completar(datos) {
    return await fetchWrapper.put(`${ruta}/agendas/completar`, datos)
  }

  async eliminar(id) {
    return await fetchWrapper.delete(`${ruta}/agendas/eliminar/${id}`)
  }

  async actualizarObservacion(datos) {
    return await fetchWrapper.put(`${ruta}/agendas/observacion`, datos)
  }

  async reporte(datos) {
    return await fetchWrapper.post(`${ruta}/agendas/reporte`, datos)
  }

  async getProductos() {
    return await fetchWrapper.get(`${ruta}/agendas/productos`)
  }
}